import { t } from "@/i18n-js/instance";
import circleAcademyFaces from "../../assets/icons/circle-academy-faces.png";
import circleAcademyStarOne from "../../assets/icons/circle-academy-star-one.png";
import circleAcademyStarTwo from "../../assets/icons/circle-academy-star-two.png";
import circleAcademyTypography from "../../assets/icons/circle-academy-typography.png";
import { CIRCLE_ACADEMY_URL } from "../../constants";

export const CircleAcademyBanner = () => {
  const handleClick = () => {
    window.open(CIRCLE_ACADEMY_URL, "_blank");
  };

  return (
    <button type="button" className="w-full text-left" onClick={handleClick}>
      <div className="bg-primary border-primary relative h-[125px] rounded-lg border shadow-sm transition-shadow hover:shadow-md">
        <div className="ml-4 flex flex-col items-start pt-8">
          <img
            src={circleAcademyFaces}
            alt={t("help_widget.explore_page.circle_academy")}
            className="w-[112px] object-contain"
            loading="eager"
          />
          <img
            src={circleAcademyTypography}
            alt={t("help_widget.explore_page.circle_academy")}
            className="ml-1 mt-2 w-[145px] object-contain dark:invert"
            loading="eager"
          />
        </div>
        <div>
          <img
            src={circleAcademyStarOne}
            alt=""
            className="absolute right-[132px] top-7 size-6"
            loading="eager"
            aria-hidden="true"
          />
          <img
            src={circleAcademyStarTwo}
            alt=""
            className="absolute bottom-5 right-16 size-8"
            loading="eager"
            aria-hidden="true"
          />
        </div>
      </div>
    </button>
  );
};
